// Module
var code = "<div class=\"d-flex align-items-center flex-column p-3 w-100\"> <div class=\"spinner-border\" style=\"width:3rem;height:3rem\" role=\"status\"> <span class=\"sr-only\">Loading...</span> </div> <h3 class=\"mt-2\">Votre paiement est en attente de validation</h3> </div> ";
// Exports
module.exports = code;